<template>
  <div class="search-tree">
    <el-popover placement="bottom-start" v-model="visible" trigger="hover" @hide="cancel">
      <div class="search-tree-content">
        <el-input placeholder="搜索关键词" v-model="filterText"></el-input>
        <div class="el-tree-style1">
          <el-scrollbar style="height: 100%;">
          <el-tree
            empty-text="无数据"
            :data="rfqSource"
            show-checkbox
            node-key="codeValue"
            :check-on-click-node="true"
            :filter-node-method="filterNode"
            ref="treeorderSource"
            :default-checked-keys="selectList"
            :props="defaultProps"
            @check-change="handleCheckOwner"
          ></el-tree>
          </el-scrollbar>
        </div>
      </div>
      <span class="el-dropdown-link" :class="num>0?'activeLink':''" slot="reference">
        询盘来源 <span v-if="num">({{num}})</span>
        <i class="el-icon-caret-bottom"></i>
      </span>
    </el-popover>
  </div>
</template>

<script>
export default {
  props: {
    rfqSource: {
      type: Array,
      default: null
    },
    selectList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      visible: false,
      filterText: "",
      defaultProps: {
        children: "childrenList",
        label: "codeStr"
      },
      ids: this.selectList,
      num: this.selectList?this.selectList.length:0
    };
  },
  watch: {
    filterText(val) {
      this.$refs.treeorderSource.filter(val);
    }
  },
  methods: {
    handleCheckOwner(data, node) {
      this.num = this.$refs.treeorderSource.getCheckedKeys().length;
      let obj = { ...this.$route.query};
      if(this.num) {
        obj.orderSource = this.$refs.treeorderSource.getCheckedKeys().join(',')
      } else {
        delete obj.orderSource;
      }
      this.$router.push({
        path: this.$route.path,
        query:obj
      })
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.codeStr.indexOf(value) !== -1;
    },
    cancel() {
      this.visible = false;
      this.filterText=''
      // this.$refs.treeorderSource.setCheckedKeys(this.selectList);
    },
    submit() {
      this.visible = false;
      let obj = { ...this.$route.query};
      if(this.num) {
        obj.orderSource = this.$refs.treeorderSource.getCheckedKeys().join(',')
      } else {
        delete obj.orderSource;
      }
      this.$router.push({
        path: this.$route.path,
        query:obj
      })
      console.log(obj)
    }
  }
};
</script>


<style lang="scss" scoped>
.search-tree-content{
  .el-input__inner{
    height: 30px;
    line-height: 30px;
  }
  .el-tree-style1 {
    height: 300px;
  }
  .action{
    margin-top: 10px;
    text-align: center;
    .el-button{
      width: auto !important;
      min-width: 70px;
    }
  }
}
:deep(.el-scrollbar__wrap){
    overflow-x: hidden;
  }
.el-dropdown-link{
  background: #FFF;
  border-radius: 2px;
  color: #222222;
  font-size: 14px;
  margin-right: 8px;
  padding: 5px 12px;
}
.activeLink{
  color: #0863ff;
}
</style>